var exports = {
  "Pf": "x2b2fbebb--e7a390--label",
  "vu": "x2b2fbebb--e7a390--active",
  "DD": "x2b2fbebb--e7a390--title",
};

module.exports = exports;
